// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"602":"184e8bd2","787":"baa63a86"}[chunkId] + ".chunk.js";
};